<template>
  <div class="user-page">
    <v-card
      outlined
      max-width="900"
      class="mb-3"
    >
      <template v-if="isLoadingUser">
        <v-skeleton-loader
          v-for="i in 2"
          :key="i"
          type="article"
          tile
          max-width="900"
        />
      </template>
      <v-card-text v-else-if="notUser">
        ユーザーが存在しません。
      </v-card-text>
      <template v-else>
        <v-row no-gutters>
          <v-col
            :class="{
              'col-12': true,
              'col-sm-6': !$route.params.userId || $route.params.userId === $_myUserData.uid
            }"
          >
            <v-card-title>
              <span>プロフィール</span>
            </v-card-title>
            <v-card-text class="text-center">
              <v-avatar
                size="70"
                color="grey lighten-4"
                class="mb-3"
              >
                <v-img
                  v-if="userData.photoURL"
                  :src="userData.photoURL"
                />
                <v-icon
                  v-else
                  size="30"
                >
                  fa-user
                </v-icon>
              </v-avatar>
              <div class="ma-1 body-1">
                {{ userData.displayName }}
              </div>
              <v-btn
                v-if="userData.username"
                fab
                depressed
                dark
                color="#1da1f2"
                x-small
                class="twitter-btn d-inline-block ma-1"
                :href="`https://twitter.com/${userData.username}`"
                target="_blank"
                rel="noopener"
              >
                <v-icon size="17">
                  fab fa-twitter
                </v-icon>
              </v-btn>
            </v-card-text>
          </v-col>
          <v-col
            v-if="!$route.params.userId || $route.params.userId === $_myUserData.uid"
            class="col-12 col-sm-6"
          >
            <v-card-title>
              <span>プレイリスト</span>
            </v-card-title>
            <v-card-text>
              <v-btn
                depressed
                block
                color="primary"
                :to="{
                  name: 'playlist',
                  params: {
                    listId: 'favorite'
                  }
                }"
              >
                お気に入り
              </v-btn>
            </v-card-text>
          </v-col>
        </v-row>
      </template>
    </v-card>

    <PostCard
      v-if="firstLoaded && !posts.length"
      no-post
    />
    <PostCard
      v-for="post in posts"
      :key="post.postId"
      :post="post"
      :show-user="false"
    />
    <div
      v-if="userData.uid && !noMorePosts"
      class="load-more"
    >
      <div
        v-if="!isLoadingPosts"
        v-intersect="loadMorePosts"
      />
      <PostCard
        v-for="i in (!posts.length ? 3 : 1)"
        :key="i"
        loader
        :show-user="false"
      />
    </div>
  </div>
</template>

<style lang="scss">
.user-page {
  > * {
    margin: auto;
  }
  .twitter-btn span {
    height: 100%;
  }
  .load-more {
    max-width: 900px;
  }
}
</style>

<script>
import firebase from 'firebase/app';
import 'firebase/firestore';

export default {
  data: () => ({
    isLoadingUser: true,
    userData: {},
    notUser: false,
    posts: [],
    noMorePosts: false,
    firstLoaded: false,
    isLoadingPosts: false
  }),
  watch: {
    async $route() {
      await this.getUserData();
    },
    '$_myUserData.isLoaded'(val) {
      if (val) {
        this.getUserData();
      } else {
        this.notUser = true;
      }
    }
  },
  mounted() {
    if (this.$_myUserData.isLoaded) {
      this.getUserData();
    }
  },
  methods: {
    async getUserData() {
      this.isLoadingUser = true;
      await firebase.firestore().collection('users').doc(this.$route.params.userId || this.$_myUserData.uid).get()
        .then(doc => {
          if (!doc.exists) {
            this.userData = {};
            throw new Error();
          }
          this.notUser = false;
          this.userData = doc.data();
          this.userData.uid = this.$route.params.userId || this.$_myUserData.uid;
          this.$_createPageTitle({ title: this.userData.displayName + ' - midies' });
        })
        .catch(err => {
          this.notUser = true;
          this.$_createPageTitle({
            title: '404 - midies',
            desc: 'ユーザーが存在しません。'
          });
          console.error(err);
        })
        .finally(() => {
          this.isLoadingUser = false;
        });
    },
    async loadMorePosts() {
      this.isLoadingPosts = true;
      let postsRef = firebase.firestore().collection('users').doc(this.userData.uid).collection('posts').orderBy('createdAt', 'desc');
      if (this.posts.length) {
        postsRef = postsRef.startAfter(this.posts.slice(-1)[0].createdAt);
      }
      await postsRef.limit(50).get()
        .then(snapshot => {
          if (snapshot.empty) {
            throw new Error();
          }
          snapshot.forEach(doc => {
            this.posts.push({
              postId: doc.id,
              ...doc.data(),
              showExplanation: false
            });
          });
        })
        .catch(err => {
          console.error(err);
          this.noMorePosts = true;
        })
        .finally(() => {
          this.isLoadingPosts = false;
          if (!this.firstLoaded) {
            this.firstLoaded = true;
          }
        });
    }
  }
};
</script>
